import*as r from"react";import{u as e}from"./useEnhancedEffect-6310da44.js";function t(t){const u=r.useRef(t);return e((()=>{u.current=t})),r.useRef(((...r)=>(0,u.current)(...r))).current}export{t as u};
